module.exports = __webpack_public_path__ + "static/media/Pink_Button.81c4263e.png";